import { render, staticRenderFns } from "./ModalCaptcha.vue?vue&type=template&id=9ca20ec0&scoped=true"
import script from "./ModalCaptcha.vue?vue&type=script&lang=js"
export * from "./ModalCaptcha.vue?vue&type=script&lang=js"
import style0 from "./ModalCaptcha.vue?vue&type=style&index=0&id=9ca20ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca20ec0",
  null
  
)

export default component.exports